import { FC, useEffect } from "react";
import bg from '../../assets/my/app-page-bg.png';
import { setBgImage } from "../../utils";
import { PageContent } from "./styled";

interface PageTemplateProps {
    children: React.ReactNode;
    bgImageUrl?: string;
    className?: string;
}

const PageTemplate: FC<PageTemplateProps> = ({
    children,
    bgImageUrl,
    className,
}) => {
    useEffect(() => {
        const bgImage = bgImageUrl || bg;
        setBgImage(bgImage);
    }, [bgImageUrl]);

    let classNames = "bg-fixed";

    if (className) {
        classNames += ' ' + className;
    }

    return (
        <div style={{ fontFamily: "'Futura', sans-serif" }} className={classNames}>
            <PageContent className="text-xl">
                {children}
            </PageContent>
        </div>
    )
}

export default PageTemplate;